const ANALYTICS_ID_BAIDU = '9bd2e701fb56c4efccb082edfe270658';

class Analytics {
  init() {
    try {
      window._hmt = window._hmt || [];

      console.log(process.env.NODE_ENV)

      if (process.env.NODE_ENV === 'production' && window.location.href.startsWith('http://survey-form.arioncc.cn/')) {
          this._creatScript();
      }
    } catch(e) {
      console.log(e);
    }
  }

  _creatScript() {
    try {
      let hm = document.createElement("script");
      hm.src = `https://hm.baidu.com/hm.js?${ANALYTICS_ID_BAIDU}`;
      let s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);
    } catch(e) {
      console.log(e);
    }
  }

  pageView(pageUrl) {
    try {
      window._hmt.push(['_setAutoPageview', false]);
      window._hmt.push(['_trackPageview', pageUrl]);
    } catch(e) {
      console.log(e);
    }
  }

  /**
   * 事件统计
   * @param params
   *      category: 要监控的目标的类型名称   必填
   *      action: 用户跟目标交互的行为       必填
   *      opt_label: 事件的一些额外信息      选填
   *      opt_value: 事件的一些数值信息      选填
   */
  trackEvent(params) {
    try {
      let { category, action, opt_label, opt_value } = params;

      if(!category || !action) return;

      window._hmt.push(['_trackEvent', category, action, opt_label, opt_value]);
    } catch(e) {
      console.log(e);
    }
  }

  setCustomVar(params) {
    try {
      let { index, name, value, opt_scope } = params;

      if(!index || !name) return;

      window._hmt.push(['_setCustomVar', index, name, value, opt_scope]);
    } catch(e) {
      console.log(e);
    }
  }
}

export default new Analytics();



// WEBPACK FOOTER //
// ./src/utils/Analytics/index.js